/** Mirrors WebApi Models.Common.NewViewerBackend.KollelFolderStatus (HAT-1446 phase 6). Unlike
 * KollelStatus, Approved/Rejected/Cancelled are all terminal — approving a folder immediately
 * creates real SupportRequests, so there is no "any status → any other status" here. */
export enum KollelFolderStatus {
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
}

export interface KollelFolderItemDtoIn {
  supportedId: number;
  firstName: string | null;
  lastName: string | null;
  paymentInfoId: number;
  excellenceAmount: number;
  examsAmount: number;
  punctualityAmount: number;
  totalAmount: number;
  /** Set once the folder is approved and the real SupportRequest for this avrech exists. */
  supportRequestId: number | null;
}

export interface KollelFolderDtoIn {
  id: number;
  kollelId: number;
  kollelName: string | null;
  fundId: number;
  /** Populated only by the management endpoints (coordinator lists are already fund-scoped). */
  fundName: string | null;
  requestedForMonth: string;
  status: KollelFolderStatus;
  statusComment: string | null;
  /** Server-computed — only PendingApproval has any (KollelFolderStatusDefinitions). */
  allowedNextStatuses: KollelFolderStatus[];
  items: KollelFolderItemDtoIn[];
  createdByEmail: string | null;
  createdAt: string;
  updatedAt: string | null;
}

/** One row of CreateKollelFolderDtoIn.items. */
export interface KollelFolderItemInputDtoIn {
  supportedId: number;
  paymentInfoId: number;
  excellenceAmount: number;
  examsAmount: number;
  punctualityAmount: number;
}

/** POST funds/{fundId}/kollels/{kollelId}/folders. */
export interface CreateKollelFolderDtoIn {
  requestedForMonth: string;
  items: KollelFolderItemInputDtoIn[];
}

/** PUT management/kollels/folders/{id}/reject. */
export interface RejectKollelFolderDtoIn {
  comment: string | null;
}
